import { NavigationVariant } from '../types/navigationVariant'

interface UseNavigationVariantProps {
  umbrellaId?: string
}

export const useNavigationVariant = ({ umbrellaId }: UseNavigationVariantProps): NavigationVariant => {
  return umbrellaId ? 'inverted' : 'default'
}
